<script setup>
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'
import JsonBlock from '@/components/Docs/JsonBlock.vue'
import Jumbo from '@/components/Docs/Jumbo.vue'
  
</script>

<template>
  <div class="row">
    <jumbo title="Fair Use">
        Our API services operate under a fair use policy to ensure equitable access for all users while maintaining system stability and performance. This policy allows users to access our API within reasonable limits, promoting responsible usage without causing undue strain on our servers or impacting the experience of other users.<br><br>

        <strong class="white">Rate limiting</strong><br>
        In order to maintain the quality of service for all users, our API implements rate limiting. Each user is provided with an allocation of requests that they can make within a specific time period.

        To provide a guideline for usage. Free users are limited to between 10 and 1000 requests per day depending on the account configuration or promotional offers. This threshold is designed to accommodate typical usage scenarios while ensuring fair access to all users. Users exceeding this limit may experience rate limiting or restrictions to their API access. Paid accounts will follow the limits set by their respective plans at the time of purchase, unless otherwise specified.
        <br><br>
        <strong class="white">Fair Use Principles</strong><br>

        Our fair use principles encourage our users to use the API responsibly and considerately. These are as follows: 

        <ul>
          <li>
            <strong>Efficient Use</strong>: Utilize API requests efficiently by minimizing unnecessary calls and optimizing data retrieval methods.
          </li>
          <li>
            <strong>Non-Abusive Behavior</strong>: Refrain from engaging in abusive or excessive API usage that could negatively impact system performance or degrade service quality for other users.
          </li>
          <li>
            <strong>Respect System Limits</strong>: Adhere to the specified rate limits and avoid attempting to bypass or circumvent them through unauthorized means.
          </li>
          <li>
            <strong>Consideration for Others</strong>: Be mindful of the needs of other users and avoid monopolizing API resources for personal or commercial gain.
          </li>

        </ul>

        <strong class="white">Monitoring and Enforcement</strong><br>

        We continuously monitor API usage patterns to identify potential abuse or violations of our fair use policy. In cases where excessive or abusive behavior is detected, we reserve the right to take appropriate actions, including but not limited to rate limiting, temporary suspensions, or termination of access privileges.

        <br><br>
        <strong class="white">Contact Us</strong><br>
        If you have any questions or concerns regarding our fair use policy or rate limiting mechanisms, please don't hesitate to contact our support team for assistance. We are committed to fostering a positive and equitable API environment for all users.
</jumbo>
  </div>
</template>


<style scoped>
</style>
